<!--
 * @Author: wankong
 * @Desc: 
 * @Date: 2022-01-09 14:25:36
 * @LastEditTime: 2022-01-10 16:05:34
-->
<template>
  <div class="products" v-lazy>
    <div class="container">
      <div class="title">
        <h3>随时随地</h3>
        <p>您也可以在下面这些地方使用意刻</p>
      </div>
      <div class="main">
        <div class="item">
          <div class="img">
            <img :src="items[0].img" alt="" />
          </div>
          <div class="desc">
            <div class="name">
              <svg
                t="1646722426796"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="18931"
                width="36"
                height="36"
              >
                <path
                  d="M337.387283 341.82659c-17.757225 0-35.514451 11.83815-35.514451 29.595375s17.757225 29.595376 35.514451 29.595376 29.595376-11.83815 29.595376-29.595376c0-18.49711-11.83815-29.595376-29.595376-29.595375zM577.849711 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763zM501.641618 401.017341c17.757225 0 29.595376-12.578035 29.595376-29.595376 0-17.757225-11.83815-29.595376-29.595376-29.595375s-35.514451 11.83815-35.51445 29.595375 17.757225 29.595376 35.51445 29.595376zM706.589595 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763z"
                  fill="#28C445"
                  p-id="18932"
                ></path>
                <path
                  d="M510.520231 2.959538C228.624277 2.959538 0 231.583815 0 513.479769s228.624277 510.520231 510.520231 510.520231 510.520231-228.624277 510.520231-510.520231-228.624277-510.520231-510.520231-510.520231zM413.595376 644.439306c-29.595376 0-53.271676-5.919075-81.387284-12.578034l-81.387283 41.433526 22.936416-71.768786c-58.450867-41.433526-93.965318-95.445087-93.965317-159.815029 0-113.202312 105.803468-201.988439 233.803468-201.98844 114.682081 0 216.046243 71.028902 236.023121 166.473989-7.398844-0.739884-14.797688-1.479769-22.196532-1.479769-110.982659 1.479769-198.289017 85.086705-198.289017 188.67052 0 17.017341 2.959538 33.294798 7.398844 49.572255-7.398844 0.739884-15.537572 1.479769-22.936416 1.479768z m346.265896 82.867052l17.757225 59.190752-63.630058-35.514451c-22.936416 5.919075-46.612717 11.83815-70.289017 11.83815-111.722543 0-199.768786-76.947977-199.768786-172.393063-0.739884-94.705202 87.306358-171.653179 198.289017-171.65318 105.803468 0 199.028902 77.687861 199.028902 172.393064 0 53.271676-34.774566 100.624277-81.387283 136.138728z"
                  fill="#28C445"
                  p-id="18933"
                ></path></svg
              >&nbsp;&nbsp;
              {{ items[0].name }}
            </div>
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img :src="items[1].img" alt="" />
          </div>
          <div class="desc">
            <div class="name">
              <svg
                t="1646722459414"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="19081"
                width="36"
                height="36"
              >
                <path
                  d="M513.5 940.36A428.48 428.48 0 0 1 346.77 117.3a428.47 428.47 0 0 1 333.46 789.39 425.62 425.62 0 0 1-166.73 33.67z m0-805.35c-207.87 0-377 169.11-377 377s169.12 377 377 377 377-169.12 377-377S721.37 135 513.5 135z"
                  fill="#1E7FFE"
                  p-id="19082"
                ></path>
                <path
                  d="M616.3 298.81c68.69 0 124.59 51.64 124.59 115.59 0 19.9-5.68 39.32-16.11 56.85-15.63 25.58-40.73 44.53-71 53.53-8.06 2.37-14.22 3.32-19.9 3.32a23.69 23.69 0 0 1 0-47.38 13.37 13.37 0 0 0 5.21-0.94c20.37-5.69 36.48-17.53 45.48-33.17a60.2 60.2 0 0 0 9-32.21c0-37.42-34.58-68.21-76.74-68.21a85.62 85.62 0 0 0-41.7 10.89c-22.26 12.79-35.52 34.11-35.52 57.32v198.5c0 40.26-22.27 77.22-59.22 98.06A130.31 130.31 0 0 1 415.44 728c-68.7 0-124.6-51.64-124.6-115.59 0-19.9 5.69-39.33 16.11-56.85C322.58 530 347.69 511 378 502c8.53-2.36 14.21-3.31 19.9-3.31a23.69 23.69 0 0 1 0 47.37 13.19 13.19 0 0 0-5.21 0.95c-20.38 6.16-36.48 18-45.48 33.16a60.25 60.25 0 0 0-9 32.22c0 37.42 34.58 68.21 77.22 68.21a85.61 85.61 0 0 0 41.69-10.89c22.26-12.79 35.52-34.11 35.52-57.32v-198c0-40.27 22.27-77.22 59.22-98.06 19.42-11.85 41.69-17.53 64.43-17.53z"
                  fill="#F4B426"
                  p-id="19083"
                ></path>
              </svg>
              &nbsp;&nbsp;
              {{ items[1].name }}
            </div>
          </div>
        </div>
        <router-link class="item" :to="{ name: 'Docs' }">
          <div class="img">
            <img :src="items[2].img" alt="" />
          </div>
          <div class="desc">
            <div class="name">
              <svg
                t="1646722500342"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="19231"
                width="36"
                height="36"
              >
                <path
                  d="M534.1 207.332c39.1-39.1 90.3-58.6 141.5-58.6 39.2 0 78.4 11.4 112.1 34.3l76.1-76.1c1.6-1.5 3.6-2.3 5.7-2.3s4.1 0.7 5.7 2.3l42.4 42.4c3.1 3.1 3.1 8.2 0 11.4l-76.1 76.1c52.7 77.8 44.6 184.5-24.3 253.5l-101.9 101.9c-1.6 1.5-3.7 2.3-5.7 2.3-2.1 0-4.1-0.7-5.7-2.3l-271.7-271.7c-3.1-3.1-3.1-8.2 0-11.3z m-225.6 225.5c1.6-1.5 3.7-2.3 5.7-2.3 1.156 0 2.282 0.212 3.327 0.67l-0.031 0.034 276.02 276.02c1.065 2.848 0.46 6.2-1.816 8.476l-101.9 101.9c-39.1 39.1-90.3 58.6-141.5 58.6-39.2 0-78.4-11.4-112.1-34.3l-76.1 76.1c-1.6 1.5-3.6 2.3-5.7 2.3s-4.1-0.7-5.7-2.3l-42.4-42.4c-3.1-3.1-3.1-8.2 0-11.3l76.1-76.1c-52.7-77.8-44.6-184.5 24.3-253.5z m273.7-177.4l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4 0-35.3-13.8-68.5-38.7-93.4-25-25-58.1-38.7-93.4-38.7-35.3 0-68.5 13.8-93.4 38.7z m-268 268l-59.4 59.4c-25 25-38.7 58.1-38.7 93.4 0 35.3 13.8 68.5 38.7 93.4 25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8z"
                  fill="#1C6EFF"
                  p-id="19232"
                ></path>
                <path
                  d="M567.811 548.615a8 8 0 0 1 11.314 0l33.941 33.941a8 8 0 0 1 0 11.314l-66.468 66.468-45.255-45.255 66.468-66.468zM429.22 410.022a8 8 0 0 1 11.313 0l33.941 33.942a8 8 0 0 1 0 11.313l-66.468 66.468-45.255-45.255 66.469-66.468z"
                  fill="#44D7B6"
                  p-id="19233"
                ></path></svg
              >&nbsp;&nbsp;
              {{ items[2].name }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          name: "微信公众号",
          img: "http://img.mmifx.com/blog/pic202204301926238.png",
          icon: "icon-xiaochengxu",
          islinks: false,
          url: "",
        },
        {
          name: "微信小程序",
          img: "http://img.mmifx.com/blog/pic202204301926238.png",
          icon: "icon-weixin",
          islinks: false,
          url: "",
        },
        {
          name: "API调用",
          img: "http://img.mmifx.com/blog/pic202204301926238.png",
          icon: "icon-jiekou-API",
          islinks: true,
          url: "Docs",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.products {
  user-select: none;
  width: 100%;
  display: flex;
  justify-content: center;
  background: #f7f9fe;
  align-items: center;
  .container {
    width: 1224px;
    .title {
      margin: 2rem 0;
      h3 {
        font-size: 2.3rem;
      }
      p {
        opacity: 0.8;
      }
    }
    .main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .item {
        display: flex;
        flex: 1;
        margin: 0 1rem;
        flex-direction: column;
        border-radius: 10px;
        overflow: hidden;
        background: #fff;
        img{
          width: 100%;
          height: 300px;
        }
        &:hover {
          background: #fff;
          box-shadow: 20px 20px 60px #bebebe;
          transform: scale(1.02);
        }
        .desc {
          padding: 1rem;
          text-align: center;
          .name {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: large;
          }
        }
      }
    }
  }
}
</style>